import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=99ed23ca"
import script from "./PreviewHeader.vue?vue&type=script&lang=js"
export * from "./PreviewHeader.vue?vue&type=script&lang=js"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&id=99ed23ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports